export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CarouselArrow.vue?vue&type=template&id=4752e50c&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/CarouselArrow.vue?vue&type=template&id=4752e50c&scoped=true
// module id = 174
// module chunks = 0